// extracted by mini-css-extract-plugin
module.exports = {"container":"_3L7SC","title":"_1E0bG","description":"_3ttKx"};